import React from "react";

const StreamsV2 = ({streams, language}) => {
    if (!streams) {
        return null
    }
    return (
        <React.Fragment>
            {streams.map(s => (
                <div className="grid-x" key={s.href[language]}>
                    <div className="large-4 cell cell-text">
                        <h2>{s.title[language].toUpperCase()}</h2>
                    </div>
                    <div className="large-offset-3 large-6 cell">
                        <div className="flex-video">
                            <iframe width="720" height="405" title={s.title[language]} src={s.href[language]} style={{border: 'none'}} allow="clipboard-write; autoplay" allowFullScreen />
                        </div>
                    </div>
                </div>
            ))}
        </React.Fragment>
    )
}

export default StreamsV2
